export default __webpack_public_path__ + "static/primaryService-fb233fb371ad4caf57a1e056ec90022e.png";